import { styled } from 'styled-components';

export const NoisePolicySelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(2)}px;
`;

export const EventAccessHeading = styled.h3`
  font-size: ${({ theme }) => theme.font.size.sm}rem;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.mono.text03};
  font-weight: ${({ theme }) => theme.font.default.weight.normal};
  margin: ${({ theme }) => theme.spacing(3)}px 0;
  padding-bottom: ${({ theme }) => theme.spacing(1.5)}px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.mono.ui05};
  letter-spacing: 0.05em;
`;

export const SelectWrapper = styled.div`
  min-width: 220px;
`;
